import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import HealthcareHero from '../components/HealthcareHero';
import AboutClinic from '../components/AboutClinic';
import TeamSection from '../components/TeamSection';
import GoogleReviewsSection from '../components/GoogleReviewsSection';
import FAQSection from '../components/FAQSection';
import LocationSection from '../components/LocationSection';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { useTranslation } from 'react-i18next';

const HealthcarePage = () => {
  const { t } = useTranslation();
  const { toast } = useToast();

  const handleDownloadClinicVCard = () => {
    const vCardData = `BEGIN:VCARD
VERSION:3.0
FN:Tonge Healthcare
ORG:Tonge Healthcare
TEL;TYPE=CELL:+91-9552374093
TEL;TYPE=OFFICE:07172-456926
TEL;TYPE=CELL:+91-8668441849
EMAIL:tongehealthcare@gmail.com
ADR;TYPE=WORK:;;Manohar Tower, Chandrapur - Durgapur Rd;Chandrapur;Maharashtra;442401;India
URL:${window.location.origin}
NOTE:Evidence-Based. Patient-Centered. Advanced Internal Medicine
END:VCARD`;

    const blob = new Blob([vCardData], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Tonge_Healthcare.vcf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    toast({
      title: 'Contact Saved!',
      description: 'Tonge Healthcare contact has been downloaded.',
      duration: 3000,
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HealthcareHero />
        <AboutClinic />
        
        {/* Services CTA Section */}
        <section className="py-20 px-4" style={{ background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)' }}>
          <div className="container mx-auto max-w-4xl text-center">
            <h2 className="text-4xl font-bold mb-4" style={{ color: 'var(--medical-primary)' }}>
              Our Medical Services
            </h2>
            <p className="text-lg text-slate-700 mb-8 max-w-2xl mx-auto">
              Explore our comprehensive range of medical services. Expert treatment for Diabetes, Hypertension, Thyroid, Cardiac conditions, and more in Chandrapur.
            </p>
            <Link to="/services">
              <Button
                size="lg"
                className="text-lg px-8 py-6 shadow-xl hover:scale-105 transition-all duration-300"
                style={{ backgroundColor: 'var(--medical-primary)' }}
              >
                View All Services
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </section>

        <TeamSection />
        <GoogleReviewsSection />
        <FAQSection />
        <LocationSection />
      </main>
      <Footer />
      
      {/* Clinic Save Contact FAB */}
      <div className="fixed bottom-6 right-6 z-40">
        <button
          onClick={handleDownloadClinicVCard}
          className="bg-white text-white shadow-2xl rounded-full px-6 py-3 transition-all duration-300 hover:scale-110"
          style={{ backgroundColor: 'var(--medical-primary)' }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--medical-primary-hover)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--medical-primary)'}
        >
          <span className="font-semibold">{t('saveContact')}</span>
        </button>
      </div>
    </div>
  );
};

export default HealthcarePage;
